// Date 2023-09-06 09:52:43

import sithMomMaterialDrawingInfo from "@/store/sithMesII/pds/SithMomMaterialDrawingInfoStore.js";
import sithMomMaterialDrawingDownloadRecord from "@/store/sithMesII/pds/SithMomMaterialDrawingDownloadRecordStore.js";

const genericEntities = [
    'sithMomMaterialDrawingInfo',
    'sithMomMaterialDrawingDownloadRecord'
]

const entities = {
    sithMomMaterialDrawingInfo,
    sithMomMaterialDrawingDownloadRecord
}

export {genericEntities}

export default entities
